export const StoreConstants = {
  authStore: 'auth',
  workstation: 'workstation',
  customer: 'customer'
};
